// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"190":"a95a7d41","317":"31c64d50","350":"92bad909","392":"d990595e","458":"0044b497","518":"889843b2","549":"e600abf6","663":"62660451","722":"6e3263ed","742":"311dfc64","800":"efa95cb7","845":"be65ff84","873":"26a60b8e"}[chunkId] + ".js";
};